import React from 'react';
import { Icon, Button, styled } from 'ykb-ui';

const ListMenuWrapper = styled.div`
  flex: 1;
`;

const ListItemButton = styled(Button)`
  width: 100%;
  border-radius: 4px !important;
  padding: 0px 5px 0px 20px !important;
  font-size: 16px !important;
  text-align: left !important;
  border: 0px !important;

  .ykb-icon {
    position: absolute;
    right: 5px;
    top: 8px;
  }

  .text {
    justify-content: space-between;
    width: 100%;
    text-overflow: ellipsis;
    flex: 1;
    display: flex;
    align-items: center;
    white-space: normal;
    svg {
      width: auto;
      height: auto;
      margin: 0px;
      width: 24px;
      height: 24px;
    }
  }
  @media (max-width: ${props => props.theme.responsiveXsMax}) {
    padding: 10px 0px 10px 40px;
    height: auto;
    background: transparent !important;
    .ykb-icon,
    svg {
      display: none;
    }
  }
`;

const ListItem = styled.div`
  flex-wrap: wrap;
  margin-bottom: 10px;
  margin-left: 5px;
  background: transparent;
  &:hover,
  &:focus {
    ${ListItemButton} {
      background: ${props => props.theme.color.primary5};
    }
  }
  &:active {
    ${ListItemButton} {
      background: ${props => props.theme.color.primary7};
    }
  }
  @media (min-width: ${props =>
      props.theme.responsiveSmMin}) and (max-width: ${props =>
      props.theme.responsiveMdMax}) {
    padding: 0px 0px 0px 10px !important;
  }

  @media (max-width: ${props => props.theme.responsiveXsMax}) {
    flex-direction: column;
    padding: 0px;
    margin: 0px;
  }
`;

export default function MegaMenuListItems({ data, handleNavClick }) {
  return (
    <ListMenuWrapper>
      {data.map(item => (
        <ListItem key={item.id}>
          <ListItemButton
            onClick={e => {
              handleNavClick(e, item);
            }}
            type="primary"
          >
            {item.title}
            <Icon name="angle-right" size={24} />
          </ListItemButton>
        </ListItem>
      ))}
    </ListMenuWrapper>
  );
}
